"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DatePicker = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var date_fns_1 = __importDefault(require("@date-io/date-fns"));
var pickers_1 = require("@material-ui/pickers");
var TextField_1 = require("../../atoms/TextField");
var EnclosedTextField_1 = require("../../atoms/EnclosedTextField");
var DatePicker = function (_a) {
    var id = _a.id, label = _a.label, enclosed = _a.enclosed, _b = _a.format, format = _b === void 0 ? "MM/dd/yyyy" : _b, // TODO: extend this to use the types from date preference
    _c = _a.margin, // TODO: extend this to use the types from date preference
    margin = _c === void 0 ? "dense" : _c, _d = _a.variant, variant = _d === void 0 ? "inline" : _d, _e = _a.value, value = _e === void 0 ? null : _e, // value must be undefined, treated like default value
    _f = _a.onChange, // value must be undefined, treated like default value
    onChange = _f === void 0 ? function () { } : _f, // onChange must be defined
    _g = _a.enclosedTextFieldProps, // onChange must be defined
    enclosedTextFieldProps = _g === void 0 ? {} : _g, rest = __rest(_a, ["id", "label", "enclosed", "format", "margin", "variant", "value", "onChange", "enclosedTextFieldProps"]);
    return ((0, jsx_runtime_1.jsx)(pickers_1.MuiPickersUtilsProvider, __assign({ utils: date_fns_1.default }, { children: (0, jsx_runtime_1.jsx)(pickers_1.KeyboardDatePicker, __assign({ id: id, label: label, format: format, margin: margin, value: value, variant: variant, onChange: function (e) {
                if ((e === null || e === void 0 ? void 0 : e.toString()) !== "Invalid Date") {
                    onChange(e);
                }
            }, 
            // TODO: revisit textfield and enclosed textfield type compatibility
            // @ts-ignore
            TextFieldComponent: enclosed ? EnclosedTextField_1.EnclosedTextField : TextField_1.TextField, KeyboardButtonProps: {
                color: "primary",
            }, PopoverProps: {
                disableRestoreFocus: true,
            }, autoOk: true }, enclosedTextFieldProps, rest)) })));
};
exports.DatePicker = DatePicker;
